import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import IconButton from '@grnhse/seedling/lib/birch/components/buttons/icon_buttons';
import AddInCircleIcon from '@grnhse/seedling/lib/birch/icons/add_in_circle';
import CloseIcon from '@grnhse/seedling/lib/birch/icons/close';
import { CompanyMode } from 'talent_matching/types';
import { withLocalePrefix } from 'shared/utils/translation';
import { type ExperienceState } from 'talent_matching/components/filters/use_experience_state';

const t = withLocalePrefix('talent_matching.filter_row.experience');

type ExperienceContentProps = {
  state: ExperienceState;
};

export const ExperienceContent = ({ state }: ExperienceContentProps) => {
  const experienceState = state;
  const {
    companyRows,
    minValue,
    maxValue,
    companyModeOptions,
    setMinValue,
    setMaxValue,
    handleCompanyNameChange,
    handleCompanyModeChange,
    handleAddCompanyRow,
    handleRemoveCompanyRow,
  } = experienceState;

  return (
    <Stack spacing={2} direction="column" alignItems="flex-start">
      <Stack spacing={1} sx={{ width: '100%' }}>
        <SecondaryBody medium>{t('description')}</SecondaryBody>
        <Stack spacing={1} direction="row" sx={{ width: '100%' }}>
          <TextInput
            label={t('minimum')}
            value={minValue}
            onChange={(e) => setMinValue(e.target.value)}
            type="number"
            min={0}
            max={100}
          />
          <TextInput
            label={t('maximum')}
            value={maxValue}
            onChange={(e) => setMaxValue(e.target.value)}
            type="number"
            min={0}
            max={100}
          />
        </Stack>
      </Stack>

      <Stack spacing={1} sx={{ width: '100%' }} alignItems="flex-start">
        <SecondaryBody medium>{t('company_experience')}</SecondaryBody>
        {companyRows.map((row) => (
          <Stack
            key={row.id}
            direction="row"
            spacing={1}
            sx={{ width: '100%', alignItems: 'center' }}
          >
            <Stack sx={{ minWidth: '164px' }}>
              <SimpleSingleDropdown
                ariaLabel={t('company_name_filter_type')}
                selectedItem={
                  companyModeOptions.find(
                    (option) => option.value === row.mode
                  ) || companyModeOptions[0]
                }
                onSelectedItemChange={(item) => {
                  handleCompanyModeChange(row.id, item.value as CompanyMode);
                }}
                items={companyModeOptions}
                clearable={false}
              />
            </Stack>
            <TextInput
              label=""
              placeholder="Company name"
              value={row.value}
              onChange={(e) => handleCompanyNameChange(row.id, e.target.value)}
            />
            <IconButton
              label="Remove"
              onClick={() => handleRemoveCompanyRow(row.id)}
              icon={CloseIcon}
              size="sm"
            />
          </Stack>
        ))}
        <TertiaryButton
          onClick={handleAddCompanyRow}
          icon={AddInCircleIcon}
          size="md"
        >
          {t('add_company')}
        </TertiaryButton>
      </Stack>
    </Stack>
  );
};
